import { render, staticRenderFns } from "./AttorneyNameChange.vue?vue&type=template&id=22645cc7&scoped=true&"
import script from "./AttorneyNameChange.vue?vue&type=script&lang=ts&"
export * from "./AttorneyNameChange.vue?vue&type=script&lang=ts&"
import style0 from "./AttorneyNameChange.vue?vue&type=style&index=0&id=22645cc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22645cc7",
  null
  
)

export default component.exports